/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ShieldLockIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="7.5" y="10.5" width="9" height="7" />
      <path d="M12,15.5 L12,13.5" />
      <path d="M9,10.5 L9,9.5 C9,7.843 10.344,6.5 12,6.5 C13.656,6.5 15,7.843 15,9.5 L15,10.5" />
      <path d="M12.5,13 C12.5,13.276 12.276,13.5 12,13.5 C11.724,13.5 11.5,13.276 11.5,13 C11.5,12.724 11.724,12.5 12,12.5 C12.276,12.5 12.5,12.724 12.5,13 Z" />
      <path d="M2.5,0.5 L21.5,0.5 L21.5,7.766 C21.5,14.368 17.843,20.426 12,23.5 C6.157,20.426 2.5,14.367 2.5,7.766 L2.5,0.5 Z" />
      <path d="M2.5,3.5 L21.5,3.5" />
    </g>
  </svg>
);

export default ShieldLockIcon;
